import styled, { css } from 'styled-components';
import { createFontSizeCSS } from '../../theme/global-style';
export const PlanTileWrapper = styled.div `
  flex-direction: column;
  align-items: center;
  display: flex;
  max-width: 525px;
  min-width: 0;
  flex: 1;

  ${({ $tileType }) => ($tileType === 'horizontal' || $tileType === 'collapse') &&
    css `
      max-width: unset;
      width: 100%;
    `}

  ${({ $tileType }) => $tileType === 'small' &&
    css `
      max-width: unset;
      width: 375px;
    `}
`;
export const PlanTileHeader = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.sm}px;
  justify-content: space-between;
  padding-inline: ${({ theme }) => theme.spacing.xl}px;
  padding-block: ${({ theme }) => theme.spacing.xl}px;

  ${({ $tileType }) => $tileType === 'small' &&
    css `
      padding-block: ${({ theme }) => theme.spacing.md}px;
      gap: ${({ theme }) => theme.spacing.xs}px;
    `}

  ${({ $tileType }) => $tileType === 'collapse' &&
    css `
      padding-inline: ${({ theme }) => theme.spacing.md}px;
      padding-block: ${({ theme }) => theme.spacing.lg}px;
    `}

  ${({ $tileType }) => $tileType === 'horizontal' &&
    css `
      flex: 1 1 0;
      min-width: 0;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) and (max-width: ${({ theme, }) => theme.breakpoints.xxl}px) {
    ${({ $tileType, theme }) => $tileType === 'standard' &&
    css `
        gap: ${theme.spacing.xs}px;
        padding-block: ${theme.spacing.md}px;
        padding-inline: ${theme.spacing.lg}px;
      `}
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-block: ${({ theme }) => theme.spacing.lg}px;
    padding-inline: ${({ theme }) => theme.spacing.md}px;
  }
`;
export const PlanTileBody = styled.div `
  width: 100%;
  padding-block: ${({ theme }) => theme.spacing.md}px;
  padding-inline: ${({ theme }) => theme.spacing.xl}px;
  gap: ${({ theme }) => theme.spacing.md}px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey_1};
  flex: 1;
  min-height: 0;

  > :first-child {
    margin-bottom: ${({ theme }) => theme.spacing.md}px;
    font-size: ${({ theme }) => theme.fonts.body1};
  }


  ${({ $tileType }) => $tileType === 'horizontal' &&
    css `
      flex: 1 1 0;
      min-width: 0;
      border-top: none;
      border-left: 1px solid ${({ theme }) => theme.colors.grey_1};
      padding-block: ${({ theme }) => theme.spacing.xl}px;
      vertical-align: middle;
    `}

  ${({ $tileType }) => $tileType === 'small' &&
    css `
      padding-block: ${({ theme }) => theme.spacing.sm}px;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) and (max-width: ${({ theme, }) => theme.breakpoints.xxl}px) {
    ${({ $tileType, theme }) => $tileType === 'standard' &&
    css `
        padding-block: ${theme.spacing.xs}px;
        padding-inline: ${theme.spacing.lg}px;
        gap: ${theme.spacing.sm}px;

        > :first-child {
          margin-bottom: ${theme.spacing.sm}px;
        }

        > div {
          row-gap: ${theme.spacing.xs}px;
        }
      `}
  }
`;
export const PlanTileCta = styled.div `
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  padding-block: ${({ theme }) => theme.spacing.md}px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) and (max-width: ${({ theme, }) => theme.breakpoints.xxl}px) {
    ${({ $tileType, theme }) => $tileType === 'standard' &&
    css `
        padding-block: ${theme.spacing.sm}px;
      `}
  }
`;
export const getPlanTheme = (planType, theme) => {
    switch (planType) {
        case 'premium':
            return {
                background: theme.colors.yellow_4,
                ctaColor: theme.colors.yellow_2,
                tagColor: theme.colors.yellow_1,
            };
        case 'expert':
            return {
                background: theme.colors.green_4,
                ctaColor: theme.colors.green_high_contrast,
                tagColor: theme.colors.green_status,
                borderColor: theme.colors.green_status,
            };
        case 'free':
            return {
                background: theme.colors.white_1,
                ctaColor: theme.colors.white_1,
                tagColor: theme.colors.green_1,
            };
        case 'custom':
            return {
                background: theme.colors.purple_5,
                ctaColor: theme.colors.purple_1,
                tagColor: theme.colors.purple_3,
            };
    }
};
const StyledPlanTile = (planType, theme) => {
    const planTheme = getPlanTheme(planType !== null && planType !== void 0 ? planType : 'free', theme);
    return css `
    ${PlanTileHeader} {
      background-color: ${planTheme.background};
    }
  `;
};
export const PlanTileCard = styled.div `
  position: relative;
  ${createFontSizeCSS('body2', false, 'regular')}
  background-color: ${({ theme }) => theme.colors.white_1};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-self: stretch;
  max-height: 550px;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow_showcase_card};
  box-sizing: border-box;
  ${({ theme, $planType }) => css `
    ${StyledPlanTile($planType || 'free', theme)};
  `}

  ${({ $highlighted, theme, $planType }) => {
    var _a;
    return $highlighted
        ? css `
          border: 4px solid ${getPlanTheme($planType !== null && $planType !== void 0 ? $planType : 'free', theme).ctaColor};
        `
        : css `
          border: 1px solid
            ${(_a = getPlanTheme($planType !== null && $planType !== void 0 ? $planType : 'free', theme).borderColor) !== null && _a !== void 0 ? _a : theme.colors.grey_1};
        `;
}};

  ${({ $tileType }) => $tileType === 'horizontal' &&
    css `
      flex-direction: row;
    `};
`;
export const PlanTileGroup = styled.div `
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;
  grid-template-rows: auto minmax(0, 1fr) auto;
  align-items: stretch;
  column-gap: ${({ theme }) => theme.spacing.md}px;
  margin: 0 auto;
  width: 100%;
  min-width: 0;

  > ${PlanTileWrapper} {
    display: grid;
    grid-row: 1 / span 3;
    grid-template-rows: subgrid;
    align-items: stretch;
    justify-items: stretch;
    width: 100%;

    > ${PlanTileCard} {
      display: grid;
      grid-row: 1 / span 3;
      grid-template-rows: subgrid;
      max-height: none;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) and (max-width: ${({ theme, }) => theme.breakpoints.xxl}px) {
    column-gap: ${({ theme }) => theme.spacing.sm}px;
  }
`;
